import { render } from "./TableSimilarSites.vue?vue&type=template&id=0a9670bc"
import script from "./TableSimilarSites.vue?vue&type=script&lang=js"
export * from "./TableSimilarSites.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__